export default __webpack_public_path__ + "static/media/Quiken_Servicios.14bc01b7.png";